import { API } from 'apis';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { OrderTransaction, PaginationList } from 'core/domain';
import { Order } from '../domain/orders-transactions/order';
import { toast } from 'react-hot-toast';

export const getAllOrders = async (
    setLoading: any,
    setData: any,
    page: number,
    itemsPerPageCount: number,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<Order>>(API.orders.getAll + `/${page}/${itemsPerPageCount}${query || ''}`).then(
        (response: any) => {
            setLoading(false);
            if (responseValidator(response.status)) {
                if (response.value) {
                    setData(response.value);
                }
            }
        },
    );
};

export const getAllOrderTypes = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth(API.orders.orderTransactionTypes).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه' }, ...response.value]);
        }
    });
};
export const getAllOrderStateTypes = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth(API.orders.orderTransactionState).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه' }, ...response.value]);
        }
    });
};

export const changeOrderStatus = async (setLoading: any, data: any, setIsOpenFalse: any) => {
    setLoading(true);
    postViaAuth(API.orders.editOrderTransaction, data).then((data) => {
        setLoading(false);
        if (responseValidator(data.status)) {
            toast.success('عملیات با موفقیت انجام شد.');
            setIsOpenFalse();
        }
    });
};

export const updateTransaction = async (setLoading: any, data: any, onSuccess: any) => {
    setLoading(true);
    // بدون await، تابع پیش از رسیدن پاسخ برمی‌گشت و فراخوانی‌کننده نمی‌توانست
    // پایان عملیات را تشخیص دهد.
    await postViaAuth(API.transaction.edit, data).then((data) => {
        setLoading(false);
        if (responseValidator(data.status)) {
            toast.success('عملیات با موفقیت انجام شد.');
            onSuccess();
        }
    });
};

export const confirmAndPayoutOrder = async (setLoading: any, data: any, setIsOpenFalse: any, getData: any) => {
    setLoading(true);
    postViaAuth<Order>(API.orders.confirmAndPayout, data).then((data) => {
        setLoading(false);
        if (responseValidator(data.status)) {
            toast.success('عملیات با موفقیت انجام شد.');
            setIsOpenFalse();
            getData();
        }
    });
};

export const createOrderTransactionOrder = async (setLoading: any, data: any, setIsOpenFalse: any, getData: any) => {
    setLoading(true);
    postViaAuth(API.orders.createOrderTransactionOrder, data).then((data) => {
        setLoading(false);
        if (responseValidator(data.status)) {
            toast.success('سفارش معامله با موفقیت ساخته شد.');
            setIsOpenFalse();
            getData();
        }
    });
};

export const getOrderDetailByTrackingCode = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setTimer: React.Dispatch<React.SetStateAction<any>>,
    trackingId: string,
) => {
    setLoading(true);
    await getViaAuth(API.orders.searchByTrackingCode + `/${trackingId}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
            const paidAt = response?.value?.deposit?.paidAt;
            if (paidAt) {
                setTimer(new Date(paidAt).getTime() + 72 * 60 * 60 * 1000);
            } else {
                setTimer(undefined);
            }
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};

export const getOrderByTrackingCode = async (setLoading: any, setData: any, trackingId: any) => {
    setLoading(true);
    await getViaAuth(API.orders.searchByTrackingCode + `/${trackingId}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([response.value]);
        } else if (response.status === 404) {
            setData([]);
        }
    });
};

export const searchOrderWithKeyword = async (
    setLoading: any,
    setData: any,
    page: number,
    itemsPerPageCount: number,
    query?: string,
    keywords?: string,
) => {
    setLoading(true);
    await getViaAuth(API.orders.searchWithKeyword + `/${page}/${itemsPerPageCount}${query || ''}`).then(
        (response: any) => {
            setLoading(false);
            if (responseValidator(response.status)) {
                setData(response.value);
            } else if (response.status === 404) {
                setData([]);
            }
        },
    );
};

export const changeSingleOrderStatus = async (
    setloader: any,
    order: Order | undefined,
    state: number,
    onComplete: () => void,
    onFail: (response: any) => any,
) => {
    await postViaAuth(API.orders.editOrderTransaction, {
        trackingCode: order?.orderTransactionTrackingCode,
        state: state,
    }).then((response: any) => {
        if (responseValidator(response.status)) {
            onComplete();
        } else {
            onFail(response);
        }
    });
};

export const confirmAndPayoutSingleOrder = async (
    setloader: any,
    order: Order | undefined,
    onComplete: () => void,
    onFail: (response: any) => any,
) => {
    setloader(true);
    await postViaAuth(API.orders.confirmAndPayout, {
        trackingCode: order?.orderTransactionTrackingCode,
    }).then((response: any) => {
        if (responseValidator(response.status)) {
            onComplete();
        } else {
            onFail(response);
        }
    });
};
